import { HStack, VStack, Box } from '@bpba/ui-components';
import { Menu } from './Menu';
import styled from 'styled-components';
import { Logout } from '../Logout';

export const MenuBar = () => {
  const customerName = localStorage.getItem('customerName') || '';

  return (
    <VStack>
      <HStack justifyContent={'end'} my={'24px'}>
        <StyledBox color={'primary.0'} fontWeight={500} fontSize={'11px'} margin={'auto 8px'} width={'fit-content'}>
          {customerName}
        </StyledBox>
        <Logout>Salir</Logout>
      </HStack>
      <Menu />
    </VStack>
  );
};

const StyledBox = styled(Box)`
  white-space: nowrap;
`;
